import request from '@/utils/request'
 // 查询例外信息列表
 export function apiScpSopExceptionsList (query) {
    return request({
      url: `/scp/scpSopExceptions/list`,
      method: 'get',
      params: query
    })
  }

 // 修改例外信息(批量修改)
  export function apiUpdateByBatchScpSopExceptionsList (query) {
    return request({
      url: `/scp/scpSopExceptions/updateByBatch`,
      method: 'post',
      data: query
    })
  }
   // 修修改例外信息(按查询条件)
   export function apiUpdateByQueryScpSopExceptionsList (query) {
    return request({
      url: `/scp/scpSopExceptions/updateByQuery`,
      method: 'post',
      data: query
    })
  }

// 修改例外明细
export function apiUpdateScpSopExceptions (data) {
  return request({
    url: `/scp/scpSopExceptions/update`,
    method: 'post',
    data: data
  })
}
